import merge from 'lodash/merge';
import pick from 'lodash/pick';

import {
  DEFAULT_FONT_FAMILY,
  DEFAULT_HEADER_AND_NAVIGATION_VALUES,
  DEFAULT_ITEM_DESCRIPTION_AND_PRICES_VALUES,
  DEFAULT_MENU_ITEM_NAME_VALUES,
  DEFAULT_MENU_SECTION_TITLE_VALUES
} from 'styles/helpers/emptyThemeValues';
import {
  TYPOGRAPHY_STYLE_ATTRIBUTES,
  TARGET_IDENTIFIERS
} from 'styles/theme/brand/constants';
import defaultTypography from 'styles/theme/typography';

export const getBaseTypography = brandStyles => {
  const h1 = pick(
    brandStyles[TARGET_IDENTIFIERS.H1],
    TYPOGRAPHY_STYLE_ATTRIBUTES
  );
  const h2 = pick(
    brandStyles[TARGET_IDENTIFIERS.H2],
    TYPOGRAPHY_STYLE_ATTRIBUTES
  );
  const h3 = pick(
    brandStyles[TARGET_IDENTIFIERS.H3],
    TYPOGRAPHY_STYLE_ATTRIBUTES
  );
  const body1 = pick(
    brandStyles[TARGET_IDENTIFIERS.PARAGRAPH],
    TYPOGRAPHY_STYLE_ATTRIBUTES
  );

  const typography = {
    h1,
    h2,
    h3,
    body1,
    fontFamily: h1?.fontFamily
  };

  return merge({}, defaultTypography, typography);
};

export const getMenuItemNamesTypography = brandStyles => {
  const fontFamily =
    brandStyles[TARGET_IDENTIFIERS.MENU_ITEM_NAME]?.fontFamily ||
    DEFAULT_FONT_FAMILY;
  const fontWeight =
    brandStyles[TARGET_IDENTIFIERS.MENU_ITEM_NAME]?.fontWeight ||
    DEFAULT_MENU_ITEM_NAME_VALUES.fontWeight;
  const textTransform =
    brandStyles[TARGET_IDENTIFIERS.MENU_ITEM_NAME]?.textTransform ||
    DEFAULT_MENU_ITEM_NAME_VALUES.textTransform;
  const letterSpacing =
    brandStyles[TARGET_IDENTIFIERS.MENU_ITEM_NAME]?.letterSpacing ||
    DEFAULT_MENU_ITEM_NAME_VALUES.letterSpacing;

  return {
    menuItemNames: {
      fontFamily,
      fontWeight,
      textTransform,
      letterSpacing
    }
  };
};

export const getMenuSectionTitlesTypography = brandStyles => {
  const fontFamily =
    brandStyles[TARGET_IDENTIFIERS.MENU_SECTION_TITLE]?.fontFamily ||
    DEFAULT_FONT_FAMILY;
  const fontSize =
    brandStyles[TARGET_IDENTIFIERS.MENU_SECTION_TITLE]?.fontSize ||
    DEFAULT_MENU_SECTION_TITLE_VALUES.fontSize;
  const fontWeight =
    brandStyles[TARGET_IDENTIFIERS.MENU_SECTION_TITLE]?.fontWeight ||
    DEFAULT_MENU_SECTION_TITLE_VALUES.fontWeight;
  const textTransform =
    brandStyles[TARGET_IDENTIFIERS.MENU_SECTION_TITLE]?.textTransform || 'none';
  const letterSpacing =
    brandStyles[TARGET_IDENTIFIERS.MENU_SECTION_TITLE]?.letterSpacing ||
    DEFAULT_MENU_SECTION_TITLE_VALUES.letterSpacing;

  return {
    menuSectionTitles: {
      fontFamily,
      fontWeight,
      fontSize,
      textTransform,
      letterSpacing
    }
  };
};

export const getHeaderTypography = brandStyles => {
  const fontFamily =
    brandStyles[TARGET_IDENTIFIERS.HEADER_NAVIGATION]?.fontFamily ||
    DEFAULT_FONT_FAMILY;
  const fontWeight =
    brandStyles[TARGET_IDENTIFIERS.HEADER_NAVIGATION]?.fontWeight ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.fontWeight;
  const textTransform =
    brandStyles[TARGET_IDENTIFIERS.HEADER_NAVIGATION]?.textTransform ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.textTransform;
  const letterSpacing =
    brandStyles[TARGET_IDENTIFIERS.HEADER_NAVIGATION]?.letterSpacing ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.letterSpacing;

  return {
    header: {
      fontFamily,
      fontWeight,
      textTransform,
      letterSpacing
    }
  };
};

export const getNavigationTypography = brandStyles => {
  const fontFamily =
    brandStyles[TARGET_IDENTIFIERS.MENU_NAVIGATION]?.fontFamily ||
    DEFAULT_FONT_FAMILY;
  const fontWeight =
    brandStyles[TARGET_IDENTIFIERS.MENU_NAVIGATION]?.fontWeight ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.fontWeight;
  const textTransform =
    brandStyles[TARGET_IDENTIFIERS.MENU_NAVIGATION]?.textTransform ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.textTransform;
  const letterSpacing =
    brandStyles[TARGET_IDENTIFIERS.MENU_NAVIGATION]?.letterSpacing ||
    DEFAULT_HEADER_AND_NAVIGATION_VALUES.letterSpacing;

  return {
    sectionNav: {
      fontFamily,
      fontWeight,
      textTransform,
      letterSpacing
    }
  };
};

export const getMenuItemDescriptionsTypography = brandStyles => {
  const fontFamily =
    brandStyles[TARGET_IDENTIFIERS.MENU_ITEM_DESCRIPTION]?.fontFamily ||
    DEFAULT_ITEM_DESCRIPTION_AND_PRICES_VALUES.fontFamily;
  const fontStyle =
    brandStyles[TARGET_IDENTIFIERS.MENU_ITEM_DESCRIPTION]?.fontStyle ||
    DEFAULT_ITEM_DESCRIPTION_AND_PRICES_VALUES.fontStyle;
  const fontWeight =
    brandStyles[TARGET_IDENTIFIERS.MENU_ITEM_DESCRIPTION]?.fontWeight ||
    DEFAULT_ITEM_DESCRIPTION_AND_PRICES_VALUES.fontWeight;
  const letterSpacing =
    brandStyles[TARGET_IDENTIFIERS.MENU_ITEM_DESCRIPTION]?.letterSpacing ||
    DEFAULT_ITEM_DESCRIPTION_AND_PRICES_VALUES.letterSpacing;

  return {
    itemDescriptionsAndPrices: {
      fontFamily,
      fontStyle,
      fontWeight,
      letterSpacing
    }
  };
};

export const getTypography = transformedBrandStyles => {
  const { menuItemNames } = getMenuItemNamesTypography(transformedBrandStyles);
  const { menuSectionTitles } = getMenuSectionTitlesTypography(
    transformedBrandStyles
  );
  const { header } = getHeaderTypography(transformedBrandStyles);
  const { sectionNav } = getNavigationTypography(transformedBrandStyles);
  const { itemDescriptionsAndPrices } = getMenuItemDescriptionsTypography(
    transformedBrandStyles
  );

  return {
    ...getBaseTypography(transformedBrandStyles),
    menuItemNames,
    menuSectionTitles,
    header,
    sectionNav,
    itemDescriptionsAndPrices
  };
};
